import { ModalProps } from "types/modal";
import { create } from "zustand";

export const ModalType = {
  LOADING: "loading",
  MOVING: "moving",
  STUDY_CHALLENGE: "study_challenge",
  NEW_MOBILE_APP_GUIDE: "new_mobile_app_guide",
  IPAD_APP_TERMINATION: "ipad_app_termination",
  MOBILE_APP_INSTALL: "mobile_app_install",
  SERVICE_NOTIFICATION: "service_notification",
  DESKTOP_GUIDE_TO_RESTART: "desktop_guide_to_restart",
  IMAGE_FULL_SCREEN: "image_full_screen",
  DESKTOP_SCALE_FACTOR_CHANGE: "desktop_scale_factor_change",
  DESKTOP_SELECT_WINDOW: "desktop_select_window",
};

interface ModalStoreProps {
  modalState: ModalProps;
  showModal: (props: ModalProps) => void;
  hideModal: () => void;
}

export const useModalStore = create<ModalStoreProps>((set) => ({
  modalState: {
    type: "",
    display: false,
    text: "",
  },
  showModal: (props) =>
    set({
      modalState: {
        ...props,
        display: true,
      },
    }),
  hideModal: () =>
    set({
      modalState: {
        type: "",
        display: false,
      },
    }),
}));
